"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _shapes = _interopRequireDefault(require("./shapes"));
var _bell = _interopRequireDefault(require("@ux/icon/bell"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Render NotificationBadge component.
 *
 * @class NotificationBadge
 * @public
 *
 * @returns {React.ReactElement} Notification alarm icon
 */

class NotificationBadge extends _react.Component {
  render() {
    const {
      isOpen,
      tooltip,
      messages = {},
      unviewedNotifications
    } = this.props;
    const bellClasses = (0, _classnames.default)('notifications-bell', {
      'no-count': unviewedNotifications
    });
    const messagesLabel = tooltip || messages.headerText;
    return /*#__PURE__*/_react.default.createElement("button", {
      "aria-expanded": isOpen,
      "aria-label": messagesLabel,
      className: bellClasses,
      title: tooltip,
      id: "notifications-bell",
      type: "button"
    }, /*#__PURE__*/_react.default.createElement(_bell.default, null), unviewedNotifications && /*#__PURE__*/_react.default.createElement("div", {
      className: "notifications-badge"
    }));
  }
}

/**
 * Property definitions.
 * @type {Object}
 *
 * @public
 */

NotificationBadge.propTypes = {
  isOpen: _propTypes.default.bool,
  /** Used as "roll over text" for the notification button */
  tooltip: _propTypes.default.string,
  /** Notification strings with translations */
  messages: _shapes.default.messages,
  /**  Provides bool where true means there are unviewed notifications. */
  unviewedNotifications: _propTypes.default.bool
};
var _default = NotificationBadge;
exports.default = _default;